module.exports = __webpack_public_path__ + "static/media/Kinnect_wall.04ab1134.jpg";